import { render, staticRenderFns } from "./TableOptimalMix.vue?vue&type=template&id=58f1e75e&scoped=true&lang=pug&"
import script from "./TableOptimalMix.vue?vue&type=script&lang=js&"
export * from "./TableOptimalMix.vue?vue&type=script&lang=js&"
import style0 from "./TableOptimalMix.vue?vue&type=style&index=0&id=58f1e75e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1e75e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VPagination,VSelect,VSimpleTable,VSkeletonLoader})
